import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const CampaignChangesCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl ? `تم تعديل حملة ترويجية` : `A campaign has been modified`
      }
    />
  )
}

export default CampaignChangesCover
